// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._dealerMap_15q6v_1 {
  /* Sizes */
  --pa-dealer-map-height-xxl-inner: var(--pa-dealer-map-height-xxl, 461px);
  --pa-dealer-map-height-xl-inner: var(--pa-dealer-map-height-xl, 461px);
  --pa-dealer-map-height-lg-inner: var(--pa-dealer-map-height-lg, 417px);
  --pa-dealer-map-height-md-inner: var(--pa-dealer-map-height-md, 580px);
  --pa-dealer-map-height-sm-inner: var(--pa-dealer-map-height-sm, 289px);
  --pa-dealer-map-height-xs-inner: var(--pa-dealer-map-height-xs, 256px);
  --pa-dealer-map-height-xxs-inner: var(--pa-dealer-map-height-xxs, 213px);
  /* End Sizes */
  position: relative;
}
@media (min-width: 1600px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  ._dealerMap__mapWrapper_15q6v_14 {
    height: var(--pa-dealer-map-height-xxs-inner);
  }
}
._dealerMap__cardContainer_15q6v_48 {
  box-sizing: border-box;
  position: absolute;
  max-width: 100%;
  width: 100%;
  height: 100%;
}
@media (max-width: 767px) {
  ._dealerMap__cardContainer_15q6v_48 {
    display: none;
  }
}
._dealerMap__row_15q6v_60 {
  height: 100%;
}
._dealerMap__dealerCard_15q6v_63 {
  z-index: 1;
}
._dealerMap__dealerLocation_15q6v_66, ._dealerMap__dealerContact_15q6v_66 {
  margin-top: var(--perxis-auto-gap-vertical-green-inner);
  margin-bottom: var(--perxis-auto-gap-vertical-green-inner);
}
._dealerMap__dealerCardInfo_15q6v_70 {
  --perxis-auto-dealer-card-padding: 0;
  --perxis-auto-dealer-card-border: 0;
  --perxis-auto-dealer-card-border-width: 0;
  --perxis-auto-dealer-card-box-shadow: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
